module.exports = __webpack_public_path__ + "static/media/howItWorks_1.52851578.svg";